export default __webpack_public_path__ + "static/media/platform1-1.4d5e8295.jpg";